// extracted by mini-css-extract-plugin
module.exports = {"slide":"PetInfoCommentList_slide_A6qiL","slide-reverse":"PetInfoCommentList_slide-reverse_12LsD","PetInfoCommentList":"PetInfoCommentList_PetInfoCommentList_1kwan"};